import { render, staticRenderFns } from "./PublishingCompaniesPanel.vue?vue&type=template&id=49a2ea7a"
import script from "./PublishingCompaniesPanel.vue?vue&type=script&lang=js"
export * from "./PublishingCompaniesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports